import { Message } from 'element-ui';
/**
 * @description 格式化列表数据 -- 数据字典转换, 事件按钮控制
 * @param {*} data
 */
export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(e => {
        e.taskStatusName = t(e.taskStatus, dictData, 'TRANSPORT_STATUS'); // 类型
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (!key) return '';
    if (!dict[dicType]) {
        Message.warning(`未获取数据字典: ${dicType}`);
        return key;
    };
    return dict[dicType][key];
};